import { render, staticRenderFns } from "./WineEdit_Mobile.vue?vue&type=template&id=22aaece2&scoped=true&"
import script from "./WineEdit_Mobile.vue?vue&type=script&lang=js&"
export * from "./WineEdit_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aaece2",
  null
  
)

export default component.exports